import {firestore} from "../firebase/clientApp";

export default function findAnswered(eventOwnerId, id, elementPlaying, user){
    return new Promise((resolve, reject) => {
        var docRef = firestore.collection(`users/${eventOwnerId}/events/${id}/queue/${elementPlaying.id}/answers`).doc(user.uid);

        docRef.get().then((doc) => {
            resolve(doc.exists);
        }).catch((error) => {
            console.log("Error getting document:", error);
            reject(error);
        });
    });
}